import { ButtonProps } from "@mui/material";

export enum ButtonVariantType {
  DEFAULT = "default",
  DEFAULT_OUTLINED = "defaultOutlined",
  PRIMARY = "primary",
  PRIMARY_OUTLINED = "primaryOutlined",
  SECONDARY = "secondary",
  SECONDARY_OUTLINED = "secondaryOutlined",
  DANGER = "danger",
  DANGER_OUTLINED = "dangerOutlined",
  SOFT = "soft",
  SOFT_OUTLINED = "softOutlined",
}
export interface CustomButtonProps extends ButtonProps {
  children: string | React.ReactNode;
  variantType?: ButtonVariantType;
  fullWidth?: boolean;
  onClick?: () => void;
  sx?: ButtonProps["sx"];
  startIcon?: React.ReactNode;
  permission?: {
    module_name: string;
    permission: string;
  };
}
